export default {
    endpoint: 'Proposta',
    componentes: [
        {
            tela: 'descricao_tecnica',
            titulo: 'DESCRIÇÃO TÉCNICA',
            chavePermissao: 'PropostaDescricaoTecnica',
        },
        {
            tela: 'ee',
            titulo: 'EMPRESAS',
            chavePermissao: 'PropostaEmpresas',
        },
        {
            tela: 'rh',
            titulo: 'RH - RECURSOS HUMANOS',
            chavePermissao: 'PropostaRecursoHumano',
        },
        {
            tela: 'st',
            titulo: 'ST - SERVIÇO DE TERCEIROS',
            chavePermissao: 'PropostaServicoTerceiro',
        },
        {
            tela: 'mc',
            titulo: 'MC - MATERIAL DE CONSUMO',
            chavePermissao: 'PropostaMaterialConsumo',
        },
        {
            tela: 'mpe',
            titulo: 'MPE - MATERIAL PERMANENTE E EQUIPAMENTO',
            chavePermissao: 'PropostaMaterialPermanente',
        },
        {
            tela: 'vd',
            titulo: 'VD - VIAGENS E DIÁRIAS',
            chavePermissao: 'PropostaViagemDiarias',
        },
        {
            tela: 'ou',
            titulo: 'OU - OUTROS',
            chavePermissao: 'PropostaOutros',
        },
        {
            tela: 'ce',
            titulo: 'CRONOGRAMA DE ETAPAS',
            chavePermissao: 'PropostaCronogramaEtapas',
        },
        {
            tela: 'e',
            titulo: 'ENTREGÁVEIS',
            chavePermissao: 'PropostaEntregaveis',
        },
        {
            tela: 'cf',
            titulo: 'CRONOGRAMA FINANCEIRO',
            chavePermissao: 'PropostaCronogramaFinanceiro',
        },
        {
            tela: 'investimentos_executora',
            titulo: 'DISTRIBUIÇÃO POR RUBRICAS',
            chavePermissao: 'PropostaInvestimento',
        }
    ]
}